var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.component)?_c(_vm.component,{tag:"component",attrs:{"formField":_vm.formField,"onChangeHandler":_vm.onChangeHandler,"compact":_vm.compact}}):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }